import React, {Component} from 'react'
import {SocialTemplateStyle} from './../../../../../styles'
import { getAverageColor } from './../../../../../helpers/getAverageColor'

import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Weibo,
  Desktop,
} from './../../../../../components'

export default class SocialTemplate extends Component {
  state = {

  }

  getIcons = (type) => {
    let nComponent = null
    switch (type) {
      case 'instagram':
        nComponent = <Instagram width={24} height={24} />
        break;
      case 'facebook':
        nComponent = <Facebook width={24} height={24} />
        break;
      case 'twitter':
        nComponent = <Twitter width={24} height={24} />
        break;
      case 'linkedin':
        nComponent = <Linkedin width={24} height={24} />
        break;
      case 'weibo':
        nComponent = <Weibo width={24} height={24} />
        break;
      case 'website':
        nComponent = <Desktop width={24} height={24} />
        break;
    
      default:
        break;
    }

    return nComponent
  }
  
  render() {
    const { fields, title, picture, picture_position, isBrand, subtitle, category } = this.props
    return (
      <div className={`product-template--social ${SocialTemplateStyle(picture)}`}>
        <div className="template-scroll flex">
          <div className={`template-left template-picture template-picture--${picture_position ? picture_position : 'center'}`}></div>
          <div className="template-right template-content">
          { category && isBrand && (<span className="title-brand">{category}</span>) }
              { title && !isBrand  && (<h2 className='subtitle'>{ title }</h2> )}
              { isBrand && subtitle  && (<h2 className={`subtitle subtitle--brand `}>{ subtitle }</h2> )}
              { title && isBrand &&  (<h3 className="subtitle-h3"> {title} </h3>)}
            <div className="social-container">
            {
                fields.items.map((social, index) => (
                  <div className="social-row flex" key={index}>
                    <span className="social-svg">
                      {
                        this.getIcons(social.type)
                      }
                    </span>
                    <span className="social-label"> { social.label } : </span>
                    <a href={social.link} target="_blank">
                      <span className="link"> { social.link } </span>
                    </a> 
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/SocialTemplate.js